import { Skeleton } from '@ui';

export const FlexiApprovedViewSkeleton = () => {
    return (
        <div data-testid="flexi-approval-view-loading">
            <Skeleton className="h-[140px] w-full rounded-m bg-secondary-80" />

            <div className="mt-2xl">
                <Skeleton className="h-xl w-full max-w-[400px] rounded-s bg-secondary-60" />
                <Skeleton className="mt-2xl h-l w-full max-w-[400px] rounded-s bg-secondary-80" />
                <Skeleton className="mt-l h-[100px] w-full rounded-s bg-secondary-80" />
            </div>

            <div className="mt-3xl">
                <Skeleton className="mt-2xl h-2xl w-full max-w-[300px] rounded-s bg-secondary-80" />
                <Skeleton className="mt-xl h-[80px] w-full rounded-s bg-secondary-80" />
                <Skeleton className="mt-xl h-[80px] w-full rounded-s bg-secondary-80" />
            </div>
        </div>
    );
};
